// extracted by mini-css-extract-plugin
module.exports = {"bookWrapper":"_2hbTX16N4zE6MaMfOLVjVA _3Y7xEtrTgaC28IokfnEvTA"};